export const delayAction = async (delay: number) => {
  await new Promise<void>((resolve) => setTimeout(() => resolve(), delay))
}
